module.exports = __webpack_public_path__ + "img/arvalis-institut-du-vegetal.6aec9ada.png";